import { getCO2Aequivalent, getCO2AequivalentGasKeys } from './getCO2Aequivalent';
import { getDatenqualitaet } from './getDatenqualitaet';
import { getEinheitenUmrechnung } from '../../bereiche/dateneingabe/functions/getEinheitUmrechung';
import { getUmrechungsFaktor } from './getUmrechnungsFaktor';
import { IDs } from '../../helpers/IDs';
import { processKennzahlenBerechnung24 } from './processKennzahlenBerechnung24';
import { processKennzahlenBerechnungCO2Scope3 } from './processKennzahlenBerechnungCO2Scope3';
import { getEmissionsFaktor } from '../../main/functions/getEmmissionsFaktor';
import { makeSimpleKennzahl } from './strukturiert/makeKennzahl';
import { Kennzahl } from './strukturiert/Kennzahl';
import { setKennzahlObj } from './strukturiert/KennzahlTools';
import { getBrennwerteUmrechnungsfaktor } from './getEmmissionsUmrechnungsfaktor';

let kennzahlen_zaehler_id = 0; // Für Kennzahlen, da wo wir keine TID haben


export function processKennzahlenBerechnungCO2(data: any, item: any, jahr: number, standort: any) {
    const konfiguration: Array<any> = data[IDs.ENT_KONFIGURATION] || [];
    const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
        || !konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
    const faktor_strom_co2 = getEmissionsFaktor(data, '', jahr, 'strom_mix');

    const keys1_1 = ['bio_brennholz', 'bio_brennholz_rm', 'bio_hackschnitzel', 'bio_hackschnitzel_srm', 'bio_holzpellets', 'bio_holzpellets_kg', 'erdgas', /*'erdgas_kwh',*/ 'erdgas_l', 'erdgas_m3', 'fluessiggas', 'fluessiggas_liter', 'fluessiggas_kg', 'hel_liter', 'hel', 'andere', 'braunkohle_kg', 'braunkohle', 'steinkohle_kg', 'steinkohle', 'biogas_m3', 'biogas_kg', 'biogas', 'biogas_kwh', 'abzug_waerme'];
    const keys1_2 = ['benzin', 'diesel', 'lpg', 'wasserstoff_kwh', 'wasserstoff_kg', 'erdgas_kraftstoff', 'erdgas_kg', 'erdgas_cng_kg', 'biodiesel', 'bioethanol', 'erdgas_lng_kg', 'abzug_kraftstoff', 'angemietete_fahrzeuge'];
    const keys1_3 = getCO2AequivalentGasKeys(data);
    const keys2_1 = ['strom', 'ladestrom', 'strom_waerme'];
    const keys2_2 = ['fernwaerme', 'fernwaerme_mwh', 'fernkaelte'];
    const keys2_4 = ['angemietete_fahrzeuge_strom', 'angemietet_strom', 'angemietet_waerme', 'angemietet_ww', 'angemietet_kaelte', 'eigene_strom', 'eigene_waerme', 'eigene_ww', 'eigene_kaelte'];
    const keys3 = ['pv', 'wind'];
    const keys_scope_1_intern = [...keys1_1, ...keys1_2];
    const keys_scope_1_extern = [...keys1_3];
    const keys_scope_2_intern = [...keys2_1];
    const keys_scope_2_extern = [...keys2_2];
    const keys_scope_3 = [...keys3];
    const keys_abzug = ['abzug_strom', 'abzug_fernwaerme', 'abzug_gase'];
    // console.log('Item CO2: ', item)
    const keys_all = [...keys_scope_1_intern, ...keys_scope_1_extern, ...keys_scope_2_intern,
    ...keys_scope_2_extern, ...keys_abzug, ...keys2_4];
    let sum_scope1 = 0;
    let sum_scope2 = 0;
    let sum_scope2_mb = 0;
    let sum_scope2_verbrauch_mb = 0;
    let sum_scope3 = 0;
    let sum_scopeOos = 0;
    let sum_scope1_renewable = 0;
    let sum_scope2_renewable = 0;
    const key_wert_s3 = 'co2_fussabdruck_s3_ss3_wert';
    const key_items_s3 = 'co2_fussabdruck_s3_ss3_items';

    const key_wert_oos1 = 'co2_fussabdruck_s3_oos1_wert';
    const key_items_oos1 = 'co2_fussabdruck_s3_oos1_items';

    const key_wert_oos2 = 'co2_fussabdruck_s3_oos2_wert';
    const key_items_oos2 = 'co2_fussabdruck_s3_oos2_items';

    item[key_items_s3] = [];
    item[key_wert_s3] = 0;

    item[key_items_oos1] = [];
    item[key_wert_oos1] = 0;

    item[key_items_oos2] = [];
    item[key_wert_oos2] = 0;

    // console.log('co2Aequivalent Klimagase KEYS 1_3', JSON.stringify(keys1_3));

    /**
     * Keys werden systemweit nicht einheitlich verwendet,
     * hier kann nach Bedarf angepasst werden
     * Hier für Keys der Art "co2_fussabdruck_[A]_[B]"
     */
    const modifyKeyCO2 = (key: string) => {
        let return_value = key;
        switch (key) {
            case 'erdgas_kwh':
                return_value = 'erdgas';
                break;
            /*case 'biogas':
                return_value = 'biogas_kwh';
                break;*/
        }
        return return_value;
    };

    /**
     * Hier andere Keys...
     */
    const modifyKey = (key: string) => {
        let return_value = key;
        switch (key) {
            case 'biogas':
            case 'bio_holzpellets':
            case 'bio_brennholz':
            case 'bio_hackschnitzel':
            case 'fernwaerme':
            case 'fernkaelte':
            case 'braunkohle':
            case 'steinkohle':
            case 'erdgas':
            case 'fluessiggas':
            case 'hel':
            case 'andere':
                return_value = key + '_kwh';
                break;
            case 'strom_waerme':
                return_value = 'strom_kwh';
                break;

        }
        return return_value;
    };

    // 1. Berechnung
    // if (+jahr === 2020) {
    //     console.log('Item 2020', standort, item);
    // }
    keys_scope_1_intern.forEach((key: string) => {
        // console.log('keys_scope_1_intern', key);
        let faktor_mengenumrechnung = 1;
        let faktor_heizwertumrechnung = { wert: 1 };
        let key_use = key;
        let name_use = null;
        // console.log('Key_use', key);
        let einheit_use = undefined;
        if (key_use === 'hel_liter') {
            key_use = 'hel';
            einheit_use = 'Liter';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'heizoel_leicht');
        }
        if (key_use === 'wasserstoff_kg') {
            key_use = 'wasserstoff';
            einheit_use = 'kg';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'wasserstoff');
        }
        if (key_use === 'fluessiggas_liter') {
            key_use = 'fluessiggas';
            einheit_use = 'Liter';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_l');
        }
        if (key_use === 'fluessiggas_kg') {
            key_use = 'fluessiggas';
            einheit_use = 'kg';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_kg');
        }
        if (key_use === 'erdgas_kwh' || key_use === 'erdgas') {
            faktor_heizwertumrechnung = getBrennwerteUmrechnungsfaktor('erdgas');
            key_use = 'erdgas';
        }
        if (key_use === 'erdgas_kg') {
            key_use = 'erdgas';
            einheit_use = 'kg';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'erdgas_kg');
        }
        if (key_use === 'erdgas_m3') {
            key_use = 'erdgas';
            einheit_use = 'm³';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'erdgas_m3');
        }
        if (key_use === 'erdgas_cng_kg') {
            key_use = 'erdgas';
            name_use = 'Erdgas CNG';
            einheit_use = 'kg';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'erdgas_cng_kg');
        }
        if (key_use === 'erdgas_lng_kg') {
            key_use = 'erdgas';
            name_use = 'Erdgas LNG';
            einheit_use = 'kg';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'erdgas_lng_kg');
        }
        if (key_use === 'benzin') {
            einheit_use = 'Liter';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'ottokraftstoffe');
        }
        if (key_use === 'diesel') {
            einheit_use = 'Liter';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'dieselkraftstoffe');
        }
        if (key_use === 'lpg') {
            einheit_use = 'Liter';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_l');
        }
        if (key_use === 'bio_brennholz_rm') {
            einheit_use = 'Rm';
            key_use = 'bio_brennholz';
            const faktor_kg = getEinheitenUmrechnung('rm', 'bio_brennholz');
            const faktor_mengenumrechnung_kwh = getUmrechungsFaktor(data, '', jahr, 'brennholz');
            faktor_mengenumrechnung = faktor_mengenumrechnung_kwh * faktor_kg.factor;
        }
        if (key_use === 'bio_hackschnitzel_srm') {
            einheit_use = 'Srm';
            key_use = 'bio_hackschnitzel';
            const faktor_kg = getEinheitenUmrechnung('srm', 'bio_hackschnitzel');
            const faktor_mengenumrechnung_kwh = getUmrechungsFaktor(data, '', jahr, 'hackschnitzel');
            faktor_mengenumrechnung = faktor_mengenumrechnung_kwh * faktor_kg.factor;
        }
        if (key_use === 'bio_holzpellets_kg') {
            einheit_use = 'Kg';
            key_use = 'bio_holzpellets';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'holzpellets');
        }
        if (key_use === 'steinkohle_kg') {
            einheit_use = 'kg';
            key_use = 'steinkohle';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'steinkohle');
        }
        if (key_use === 'braunkohle_kg') {
            key_use = 'braunkohle';
            einheit_use = 'kg';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'braunkohle');
        }
        if (key_use === 'biogas_kwh') {
            faktor_heizwertumrechnung = getBrennwerteUmrechnungsfaktor('biogas');
            key_use = 'biogas';
            einheit_use = 'kwh';

        }
        if (key_use === 'biogas_kg') {
            einheit_use = 'kg';
            key_use = 'biogas';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'biogas_kg');
        }
        if (key_use === 'biogas_m3') {
            einheit_use = 'm³';
            key_use = 'biogas';
            faktor_mengenumrechnung = getUmrechungsFaktor(data, '', jahr, 'biogas_m3');
        }

        // WKETOOL-300: Kein Heizwert/Brennwert-Faktor bei der Berechnung von Emissionen, die nicht in kWh angegeben sind.
        // if (key_use === 'erdgas' ||
        //     key_use === 'fluessiggas' ||
        //     key_use === 'biogas' ||
        //     key_use === 'bio_brennholz' ||
        //     key_use === 'bio_hackschnitzel' ||
        //     key_use === 'bio_holzpellets' ||
        //     key_use === 'hel' ||
        //     key_use === 'braunkohle' ||
        //     key_use === 'steinkohle') {
        //     // Für alle Keys ohne Einheit (d.h. Einheit = kWH)
        //     faktor_heizwertumrechnung = getBrennwerteUmrechnungsfaktor(key_use);
        // }

        // if (key === 'andere') {
        //     console.log('andere', item);
        // }

        const aq = getCO2Aequivalent(data, jahr, key_use, false);

        // const key_wert = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_wert';
        const key_wert = 'co2_fussabdruck_' + key + '_wert';
        if (key === 'abzug_kraftstoff' || key === 'abzug_waerme') {
            if (item[key_wert]) {
                sum_scope1 += item[key_wert];
            }
            return;
        }
        const factor_s3 = aq.wert3;
        const factor_oos = aq.wertOut;
        const key_menge = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_menge';
        const key_faktor = 'faktor_co2_' + key;
        const key_quelle = 'faktor_co2_quelle_' + key;
        const key_datenqualitaet = modifyKey(key) + '_datenqualitaet';
        const key_co2_datenqualitaet = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_datenqualitaet';
        const factor = (item[key_faktor] || item[key_faktor] === 0) ? item[key_faktor] : aq.wert;
        const menge = (item[key_menge] || 0);
        const quelle = aq ? aq.quelle : null;

        const datenqualitaet: any = item[key_datenqualitaet] || [];

        // if (key === 'fluessiggas_liter') {
        //     console.log('CO2 1i', jahr, key, key_use, faktor_mengenumrechnung, aq, key_menge, menge);
        // }
        // console.log('UM1', key_wert, key_use, key_menge, menge, faktor_mengenumrechnung, faktor_heizwertumrechnung);

        if (menge > 0) {
            const co2_aq = (menge * factor * faktor_mengenumrechnung * (faktor_heizwertumrechnung ? faktor_heizwertumrechnung.wert : 1));
            item[key_wert] = co2_aq;
            // console.log('UM2', key_wert, key_menge, menge, key_use, co2_aq, faktor_mengenumrechnung, faktor_heizwertumrechnung);
            item[key_quelle] = quelle;
            item[key_co2_datenqualitaet] = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_1);
            if (!isNaN(co2_aq)) {
                sum_scope1 += co2_aq;
                if (key_use === 'biogas' ||
                    key_use === 'bio_brennholz' ||
                    key_use === 'bio_hackschnitzel' ||
                    key_use === 'bio_holzpellets') {
                    sum_scope1_renewable += co2_aq;
                }
            }
            // console.log('DQ' , key_datenqualitaet, jahr, key_use, aq, item[key_co2_datenqualitaet]);
            // console.log('processKennzahlen...', key, modifyKeyCO2(key), getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_1), menge, jahr, standort);
            // S3
            // console.log('1 Intern', key_menge, jahr, item[key_menge], menge, factor_s3, aq);
            if (!disabledCO2Komplex) {
                // console.log('S3 1 intern keys', key, standort, key_datenqualitaet, key_co2_datenqualitaet, datenqualitaet, item[key_co2_datenqualitaet]);
                const co2_aq_s3 = (menge * factor_s3 * faktor_mengenumrechnung);
                const row: any = {};
                kennzahlen_zaehler_id++;
                row.tid = kennzahlen_zaehler_id;
                row.value = co2_aq_s3;
                row.name = name_use || aq.name;
                row.menge = menge;
                row.faktor = factor_s3 * faktor_mengenumrechnung * 1000000; // Nur für die Ausgabe
                row.einheit = einheit_use || aq.einheit;
                row.quelle = aq ? aq.quelle2 : null;
                row.decimals = 0;
                row.faktor_einheit = 'gCO₂Äq/' + row.einheit;
                // row.datenqualitaet = item[key_co2_datenqualitaet];
                row.datenqualitaet = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_2);
                // console.log('RS3', row.name, aq);
                if (factor_s3) {
                    item[key_items_s3].push(row);
                    if (!isNaN(co2_aq_s3)) {
                        item[key_wert_s3] = (item[key_wert_s3] || 0) + co2_aq_s3;
                        sum_scope3 += co2_aq_s3;
                    }
                }
                // Kennzahl erstellen
                const einheit_mengenumrechnung = `kWh/${row.einheit}`;
                makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss3_' + row.tid, jahr, standort ? standort.tid : 'ALL', row.tid,
                    'Verbrauch', row.name, row.menge, row.value, row.einheit,
                    aq.wert3, aq.quelle2, data, undefined, faktor_mengenumrechnung, einheit_mengenumrechnung);
            }
            if (factor_oos) {
                const co2_aq_oos = (menge * factor_oos * faktor_mengenumrechnung);
                const row_oos: any = {};
                row_oos.value = co2_aq_oos;
                row_oos.name = name_use || aq.name;
                row_oos.menge = menge;
                row_oos.faktor = factor_oos * faktor_mengenumrechnung * 1000000; // Nur für die Ausgabe
                row_oos.einheit = einheit_use || aq.einheit;
                row_oos.quelle = aq ? aq.quelle3 : null;
                row_oos.datenqualitaet = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_3);
                row_oos.decimals = 0;
                row_oos.faktor_einheit = 'gCO₂Äq/' + (einheit_use || aq.einheit);
                row_oos.kennKey = `s3_oos_${key}`;
                row_oos.jahr = jahr;
                const key_oos_wert = keys1_1.indexOf(key) > -1 ? key_wert_oos1 : key_wert_oos2;
                const key_oos_items = keys1_1.indexOf(key) > -1 ? key_items_oos1 : key_items_oos2;
                item[key_oos_items].push(row_oos);
                if (!isNaN(co2_aq_oos)) {
                    item[key_oos_wert] = (item[key_oos_wert] || 0) + co2_aq_oos;
                    sum_scopeOos += co2_aq_oos;
                }

                // WKETOOL-167: setKennzahl
                setKennzahlS3OOS(standort, data, row_oos, datenqualitaet);
            }
        }
    });
    keys_scope_1_extern.forEach((key: string) => {
        // console.log('keys_scope_1_extern', key);
        const aq = getCO2Aequivalent(data, jahr, key, true);
        const factor = aq.wert;
        const key_menge = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_menge';
        const key_wert = 'co2_fussabdruck_' + key + '_wert';
        const key_datenqualitaet = modifyKey(key) + '_datenqualitaet';
        const key_co2_datenqualitaet = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_datenqualitaet';
        const menge = item[key_menge] || 0;
        const datenqualitaet: any = item[key_datenqualitaet] || [];

        if (menge > 0) {
            // console.log('KG:', key, menge, aq);
            // Scope 1
            const co2_aq = (menge * factor) / 1000;
            // S1
            item[key_wert] = co2_aq;
            item[key_co2_datenqualitaet] = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet);
            sum_scope1 += co2_aq;
        }
    });
    item.co2_fussabdruck_scope1 = sum_scope1;
    item.co2_fussabdruck_scope1_renewable = sum_scope1_renewable;
    keys_scope_2_intern.forEach((key: string) => {
        // console.log('keys_scope_2_intern', key);
        const aq = getCO2Aequivalent(data, jahr, key, false);
        const key_menge = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_menge';
        const key_wert = 'co2_fussabdruck_' + key + '_wert';
        const key_co2 = 'co2_fussabdruck_' + key + '_co2';
        const key_einheit = 'co2_fussabdruck_' + key + '_einheit';
        const key_datenqualitaet = modifyKey(key) + '_datenqualitaet';
        const key_co2_datenqualitaet = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_datenqualitaet';
        // const key_faktor = 'faktor_' + key + '_co2';
        let key_faktor = 'faktor_strom_co2_calc';
        if (key === 'strom_waerme' && (item['faktor_co2_strom'] || item['faktor_co2_strom'] === 0)) {
            key_faktor = 'faktor_co2_strom';
        }
        const factor = (item[key_faktor] || item[key_faktor] === 0) ? item[key_faktor] : aq.wert;
        const factor_s3 = aq.wert3;
        const factor_oos = aq.wertOut;
        const co2 = item[key_co2];
        const menge = item[key_menge] || 0;
        const einheit = item[key_einheit] || '';
        const datenqualitaet: any = item[key_datenqualitaet] || [];

        if (menge > 0) {
            const co2_aq = (co2 || co2 === 0) ? co2 : (menge * factor);
            // console.log('2 Intern', jahr, key_faktor, jahr, menge, factor);
            item[key_wert] = co2_aq;
            item[key_co2_datenqualitaet] = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_2);
            sum_scope2 += co2_aq;

            // WKETOOL-175: #92, 93
            if (key === 'strom') {
                const isMarketBased = factor !== faktor_strom_co2;
                if (isMarketBased) {
                    sum_scope2_mb += co2_aq;
                    sum_scope2_verbrauch_mb += menge;
                }
                // console.log('Strom-Faktor: ', jahr, factor);
                if (factor <= 0.000099) {
                    sum_scope2_renewable += co2_aq;
                }
            }

            // S3
            if (!disabledCO2Komplex) {
                // console.log('S3 2 keys', key, standort, key_datenqualitaet, key_co2_datenqualitaet, datenqualitaet, item[key_co2_datenqualitaet]);
                const co2_aq_s3 = (menge * factor_s3);
                const row: any = {};
                kennzahlen_zaehler_id++;
                row.tid = kennzahlen_zaehler_id;
                row.value = co2_aq_s3;
                row.name = aq.name;
                row.faktor = factor_s3 * 1000000;
                row.quelle = aq.quelle2;
                row.decimals = 0;
                row.faktor_einheit = 'gCO₂Äq/' + aq.einheit;
                row.einheit = aq.einheit;
                row.menge = menge;
                // row.datenqualitaet = item[key_co2_datenqualitaet];
                row.datenqualitaet = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_2);
                item[key_items_s3].push(row);
                item[key_wert_s3] = (item[key_wert_s3] || 0) + co2_aq_s3;
                sum_scope3 += co2_aq_s3;

                // Kennzahl erstellen
                makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss3_' + row.tid, jahr, standort ? standort.tid : 'ALL', row.tid,
                    'Verbrauch', row.name, row.menge, row.value, row.einheit,
                    factor_s3, aq.quelle2, data);
                //    console.log('KZ S3 ', row.name, row.menge, row.value, 'ss3_' + row.tid);
            }
            if (factor_oos) {
                const co2_aq_oos = (menge * factor_oos);
                const row_oos: any = {};
                row_oos.value = co2_aq_oos;
                row_oos.name = aq.name;
                row_oos.quelle = aq.quelle3;
                row_oos.menge = menge;
                row_oos.faktor = factor_oos * 1000000; // Nur für die Ausgabe
                row_oos.einheit = aq.einheit;
                row_oos.decimals = 0;
                row_oos.faktor_einheit = 'gCO₂Äq/' + aq.einheit;
                row_oos.datenqualitaet = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_3);
                row_oos.kennKey = `s3_oos_${key}`;
                row_oos.jahr = jahr;
                item[key_items_oos2].push(row_oos);
                if (!isNaN(co2_aq_oos)) {
                    item[key_wert_oos2] = (item[key_wert_oos2] || 0) + co2_aq_oos;
                    sum_scopeOos += co2_aq_oos;
                }

                // WKETOOL-167: setKennzahl
                setKennzahlS3OOS(standort, data, row_oos, datenqualitaet);
            }
        }
    });
    keys_scope_2_extern.forEach((key: string) => {
        // console.log('keys_scope_2_extern', key);
        let key_use = key;
        let einheit_use = 'kWh';
        let faktor_mengenumrechnung = 1;
        if (key === 'fernwaerme_mwh') {
            einheit_use = 'MWh';
            key_use = 'fernwaerme';
            faktor_mengenumrechnung = 1000;
        }
        const aq = getCO2Aequivalent(data, jahr, key_use, false);
        const key_faktor = 'faktor_co2_' + key_use;
        const factor = (item[key_faktor] || item[key_faktor] === 0) ?
            item[key_faktor]
            : aq.wert * faktor_mengenumrechnung;
        const factor_s3 = aq.wert3 * faktor_mengenumrechnung;
        const key_menge = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_menge';
        const key_wert = 'co2_fussabdruck_' + key + '_wert';
        const key_value = 'co2_fussabdruck_' + key + '_value';
        const key_datenqualitaet = modifyKey(key) + '_datenqualitaet';
        const key_co2_datenqualitaet = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_datenqualitaet';
        const menge = item[key_menge] || 0;
        const co2_value = item[key_value];
        const datenqualitaet: any = item[key_datenqualitaet] || [];
        const key_quelle = 'faktor_co2_quelle_' + key_use;
        const quelle = aq ? aq.quelle : null;

        if (menge > 0) {
            const co2_aq = menge * factor;
            item[key_wert] = co2_aq;
            item[key_co2_datenqualitaet] = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_2);
            if (!item[key_quelle]) {
                item[key_quelle] = quelle;
            }

            if (key === 'fernwaerme') {
                // fernwaerme = fernwaerme kWh + fernwaerme mWh
                sum_scope2 += co2_value;
            } else if (key === 'fernwaerme_mwh') {
                // Da mWh bereits in kWh enthalten ist, soll es nicht verdoppelt addiert werden.
            } else {
                sum_scope2 += co2_aq;
            }

            // S3
            if (!disabledCO2Komplex && factor_s3) {
                // console.log('S3 2 extern keys', key, standort, key_datenqualitaet, key_co2_datenqualitaet, datenqualitaet, item[key_co2_datenqualitaet]);
                const co2_aq_s3 = (menge * factor_s3);
                const row: any = {};
                kennzahlen_zaehler_id++;
                row.tid = kennzahlen_zaehler_id;
                row.value = co2_aq_s3;
                row.name = aq.name;
                row.quelle = aq.quelle2;
                row.faktor = factor_s3 * 1000000;
                row.menge = menge;
                row.einheit = einheit_use || aq.einheit;
                row.decimals = 0;
                row.faktor_einheit = 'gCO₂Äq/' + einheit_use;
                // row.datenqualitaet = item[key_co2_datenqualitaet];
                row.datenqualitaet = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_2);
                item[key_items_s3].push(row);
                if (!isNaN(co2_aq_s3)) {
                    item[key_wert_s3] = (item[key_wert_s3] || 0) + co2_aq_s3;
                }
                sum_scope3 += co2_aq_s3;
                // Kennzahl erstellen
                const einheit_mengenumrechnung = `kWh/${row.einheit}`;
                makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss3_' + row.tid, jahr, standort ? standort.tid : 'ALL', row.tid,
                    'Verbrauch', row.name, row.menge, row.value, row.einheit,
                    aq.wert3, aq.quelle2, data, undefined, faktor_mengenumrechnung, einheit_mengenumrechnung);

            }
        }
    });
    item.co2_fussabdruck_scope2 = sum_scope2;
    // Die Vorketten die es nur im Scope3 gibt
    keys_scope_3.forEach((key: string) => {
        // console.log('keys_scope_3', key);
        const aq = getCO2Aequivalent(data, jahr, key, false);
        const factor_s3 = aq.wert3;
        const key_menge = 'co2_fussabdruck_' + key + '_menge';
        const menge = item[key_menge] || 0;
        const key_datenqualitaet = modifyKey(key) + '_datenqualitaet';
        const key_co2_datenqualitaet = 'co2_fussabdruck_' + modifyKeyCO2(key) + '_datenqualitaet';
        const datenqualitaet: any = item[key_datenqualitaet] || [];
        // console.log('processKennzahlen S3', key);
        // console.log('3 Extern', key_menge, jahr, item[key_menge], menge, factor_s3);
        if (menge > 0) {
            // S3
            item[key_co2_datenqualitaet] = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_3);
            if (!disabledCO2Komplex) {
                // console.log('S3 3 keys', key, standort, key_datenqualitaet, key_co2_datenqualitaet, datenqualitaet, item[key_co2_datenqualitaet]);
                const co2_aq_s3 = (menge * factor_s3);
                const row: any = {};
                kennzahlen_zaehler_id++;
                row.tid = kennzahlen_zaehler_id;
                row.value = co2_aq_s3;
                row.name = aq.name;
                row.quelle = aq.quelle2;
                row.faktor = factor_s3 * 1000000;
                row.menge = menge;
                row.einheit = 'kWh';
                row.decimals = 0;
                row.faktor_einheit = 'gCO₂Äq/kWh';
                row.datenqualitaet = getDatenqualitaet(datenqualitaet, (aq || {}).datenqualitaet_2);
                item[key_items_s3].push(row);
                item[key_wert_s3] = (item[key_wert_s3] || 0) + co2_aq_s3;
                sum_scope3 += co2_aq_s3;
                // Kennzahl
                makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss3_' + row.tid, jahr, standort ? standort.tid : 'ALL', row.tid,
                    'Menge', row.name, row.menge, row.value, row.einheit,
                    factor_s3, aq.quelle2, data);
                //    console.log('KZ S3 ', row.name, row.menge, row.value, 'ss3_' + row.tid);
                // console.log('s3_3', jahr, sum_scope3, co2_aq_s3, factor_s3);
                /*if (+jahr === 2021) {
                    console.log('SS3-2.2', co2_aq_s3, item[key_wert_s3], row, aq);
                }*/
            }
        }
    });

    // 2. Summen bilden
    item.co2_fussabdruck_scope3 = sum_scope3;
    item.co2_fussabdruck_scope_oos = sum_scopeOos;
    item.co2_fussabdruck_total = item.co2_fussabdruck_scope1 + item.co2_fussabdruck_scope2 + item.co2_fussabdruck_scope3;
    item.co2_fussabdruck_zuschlag = item.co2_zuschlag;
    // console.log('CO2Total: ',   item.co2_fussabdruck_total,  item.co2_fussabdruck_scope1, item.co2_fussabdruck_scope2, item.co2_fussabdruck_scope3)
    // console.log('CO2', jahr, item.co2_fussabdruck_total, sum_scope1, sum_scope2, sum_scope3);

    // An dieser Stelle müssen wir den Scope 3 berechnen, bevor wir die Anteile ermitteln können
    // console.log('processKennzahlenBerechnungCO2Scope3');
    processKennzahlenBerechnung24(data, item, jahr, standort);
    if (!disabledCO2Komplex) {
        processKennzahlenBerechnungCO2Scope3(data, item, jahr, standort);
    }
    let factor_zuschlag = (1 + (+item.co2_zuschlag / 100));
    if (!standort) {
        const zuschlagGesamt = getZuschlagGesamt(jahr, data);
        // console.log('FACTOR GESAMT', zuschlagGesamt);
        factor_zuschlag = (1 + (zuschlagGesamt / 100));
    }


    item.co2_fussabdruck_total_zuschlag = (item.co2_fussabdruck_total) * factor_zuschlag;
    item.co2_fussabdruck_oos_zuschlag = (item.co2_fussabdruck_scope_oos) * factor_zuschlag;

    // 3. Anteil bestimmen
    keys_all.forEach((key: string) => {
        const key_wert = 'co2_fussabdruck_' + key + '_wert';
        const key_anteil = 'co2_fussabdruck_' + key + '_anteil';
        const wert = item[key_wert] || 0;
        if (wert > 0 || key === 'abzug_kraftstoff' || key === 'abzug_strom' || key === 'abzug_fernwaerme'
            || key === 'abzug_waerme' || key === 'abzug_gase') {
            item[key_anteil] = (100 / item.co2_fussabdruck_total) * wert;
        }
    });
    item.co2_fussabdruck_scope1_anteil = (100 / item.co2_fussabdruck_total) * item.co2_fussabdruck_scope1;
    item.co2_fussabdruck_scope2_anteil = (100 / item.co2_fussabdruck_total) * item.co2_fussabdruck_scope2;
    item.co2_fussabdruck_scope3_anteil = (100 / item.co2_fussabdruck_total) * item.co2_fussabdruck_scope3;

    // market_based / location_based
    // market_based ist immer der Faktor, den der User eingegeben hat.
    // location_based ist der Standard-Faktor, der genommen wird, falls kein Faktor eingegeben wurde.
    item.co2_fussabdruck_scope2_verbrauch_mb = sum_scope2_verbrauch_mb;
    item.co2_fussabdruck_scope2_renewable = sum_scope2_renewable;
    item.co2_fussabdruck_scope2_mb = sum_scope2_mb;
    item.co2_fussabdruck_scope2_lb = ((item.verbrauch_waerme_strom_kwh || 0) +
        (item.co2_fussabdruck_scope2_verbrauch_mb || 0) +
        (item.ladestrom_kwh || 0) +
        (item.co2_fussabdruck_angemietet_strom_menge || 0)) * faktor_strom_co2 + (item.co2_fussabdruck_fernwaerme_wert || 0);
    // WKETOOL-219
    item.co2_fussabdruck_scope1_scope2_lb = item.co2_fussabdruck_scope1 + item.co2_fussabdruck_scope2_lb;
    item.co2_fussabdruck_scope1_scope2_mb = item.co2_fussabdruck_scope1 + item.co2_fussabdruck_scope2_mb;
    item.co2_fussabdruck_total_lb = item.co2_fussabdruck_scope1 + item.co2_fussabdruck_scope2_lb + item.co2_fussabdruck_scope3;
    item.co2_fussabdruck_total_mb = item.co2_fussabdruck_scope1 + item.co2_fussabdruck_scope2_mb + item.co2_fussabdruck_scope3;

    if (item.mitarbeiter) {
        item.co2_fussabdruck_ma = item.co2_fussabdruck_total / item.mitarbeiter;
    }
    // console.log('Umsatz: ', item);
    if (item.umsatz) {
        item.co2_fussabdruck_umsatz = (item.co2_fussabdruck_total / item.umsatz) * 1000;
    }
    if (item.co2_fussabdruck_total > 0) {
        //  console.log('SCOPE TOTAL', item);
    }
}

function setKennzahlS3OOS(standort: any, data: any, row_oos: any, datenqualitaet: Array<any>) {
    if (standort) {
        if (Array.isArray(datenqualitaet)) {
            datenqualitaet.forEach((dq: any, idx: number) => {
                const rowCopy = { ...row_oos };
                rowCopy.menge = dq.wert;
                setKennzahlObj({
                    standort_tid: standort.tid,
                    data,
                    kennName: `Menge ${rowCopy.name}`,
                    bereich: Kennzahl.BEREICH_OOS,
                    key: `${rowCopy.kennKey}_${idx}`,
                    field: 'menge',
                    item: rowCopy,
                    einheit: rowCopy.einheit,
                    gesamtKey: `${rowCopy.kennKey}_gesamt`,
                    gesamtName: `Menge ${rowCopy.name} Gesamt`,
                });
                if (rowCopy.faktor || rowCopy.faktor === 0) {
                    // g -> t
                    const faktor = +rowCopy.faktor / 1000000;
                    const faktor_einheit = (rowCopy.faktor_einheit || '').replace('gCO₂', 'tCO₂');
                    const co2Params = {
                        standort_tid: standort.tid,
                        data,
                        kennName: `CO₂-Emission ${rowCopy.name}`,
                        bereich: Kennzahl.BEREICH_OOS,
                        key: `${rowCopy.kennKey}_${idx}_co2`,
                        field: 'menge',
                        item: rowCopy,
                        einheit: 'tCO₂Äq',
                        einheitOrig: rowCopy.einheit,
                        gesamtKey: `${rowCopy.kennKey}_co2_gesamt`,
                        gesamtName: `CO₂-Emission ${rowCopy.name} Gesamt`,
                        faktor_co2: faktor,
                        faktor_co2_einheit: faktor_einheit,
                        faktor_co2_quelle: rowCopy.quelle
                    };
                    setKennzahlObj(co2Params);

                    // Out of Scope: Gesamtemissionen aus biogenen Anteilen
                    const co2ParamsGesamt = {
                        ...co2Params,
                        key: `${co2Params.key}_temp1`,
                        gesamtKey: `oos_co2_gesamt`,
                        gesamtName: `OOS: Gesamtemissionen aus biogenen Anteilen`,
                        hidden: true
                    };
                    setKennzahlObj(co2ParamsGesamt);
                }
            });
        }
    }
}
function getZuschlagGesamt(jahr: number, data: any): number {
    // FIXME: Zusammenführen mit der Render-Funktion in der CO2-Detail-Auswertung
    const zuschlagRows = data[IDs.ENT_CO2_SICHERHEITSZUSCHLAG] || [];
    const kennStandorte = data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {};
    const standorte = Object.keys(kennStandorte).filter((s: string) => kennStandorte[s][jahr].co2_fussabdruck_total > 0);
    // console.log('FACTOR GESAMT ZUS', zuschlagRows);
    let sumEmi = 0;
    let sumEmiZus = 0;
    let zusWgt = 0;
    standorte.forEach((s: string) => {
        const emi = kennStandorte[s][jahr].co2_fussabdruck_total;
        const zusFnd = zuschlagRows.find((r: any) => +r.standort_tid_orig === +s && +r.jahr === +jahr && r.zuschlag >= 0);
        if (zusFnd) {
            sumEmi += emi;
            sumEmiZus += emi * zusFnd.zuschlag;
        }
        // console.log('FACTOR GESAMT DETAUL: ', emi, s, zusFnd);
    });
    if (sumEmi !== 0) {
        zusWgt = sumEmiZus / sumEmi;
    }
    return zusWgt;
}
